// extracted by mini-css-extract-plugin
module.exports = {"caption-input":"styles_caption-input__3QrMr"};